// TestFecthStatus.jsx
import React, { useContext, useEffect, useState } from "react";
import { DContext } from "../../context/Datacontext";
import { TestFetchOverAllStatus } from "../services/TestFetchOverAllStatus";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const TestFecthStatus = () => {
    const { BeURL } = useContext(DContext);

    const [overAllStatus, setOverAllStatus] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        TestFetchOverAllStatus(BeURL, setOverAllStatus);
    }, [BeURL]);

    // Search Filter
    const filteredData = overAllStatus.filter((item) => {
        const keyword = search.toLowerCase();

        return (
            item?.job?.title?.toLowerCase().includes(keyword) ||
            item?.candidate?.name?.toLowerCase().includes(keyword) ||
            item?.candidate?.email?.toLowerCase().includes(keyword) ||
            item?.candidate?.number?.toString().includes(keyword) ||
            item?.statusType?.toLowerCase().includes(keyword) ||
            item?.submittedBy?.name?.toLowerCase().includes(keyword) ||
            item?.recentStatus?.status?.toLowerCase().includes(keyword)
        );
    });

    // Excel Download
    const downloadExcel = () => {
        const excelData = filteredData.map((item, index) => ({
            "Sl.No": index + 1,
            "Job Title": item?.job?.title,
            "Candidate Name": item?.candidate?.name,
            Email: item?.candidate?.email,
            Contact: item?.candidate?.number,
            "Status Type": item?.statusType,
            "Submitted By": item?.submittedBy?.name,
            "Recent Status": item?.recentStatus?.status,
            "DOJ": item?.recentStatus?.doj || "-",
            "scheduledDate": item?.recentStatus?.scheduledDate || "-", 
            "Recent Time": new Date(
                item?.recentStatus?.timestamp
            ).toLocaleString(),
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Overall Status"
        );

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const fileData = new Blob([excelBuffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(fileData, "Overall_Status_Report.xlsx");
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:justify-between gap-3 mb-5">
                <h2 className="text-2xl font-bold text-gray-800">
                    Overall Status
                </h2>

                <div className="flex gap-2">
                    <input
                        type="text"
                        placeholder="Search anything..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="border px-4 py-2 rounded-lg w-full md:w-72"
                    />

                    <button
                        onClick={downloadExcel}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                    >
                        Download Excel
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
                <table className="min-w-full text-sm text-left">
                    <thead className="bg-gray-800 text-white">
                        <tr>
                            <th className="px-4 py-3">Sl.No</th>
                            <th className="px-4 py-3">Job Title</th>
                            <th className="px-4 py-3">Candidate Name</th>
                            <th className="px-4 py-3">Email</th>
                            <th className="px-4 py-3">Contact</th>
                            <th className="px-4 py-3">Status Type</th>
                            <th className="px-4 py-3">Submitted By</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Doj</th>
                            <th className="px-4 py-3">Schedule Date</th>
                            <th className="px-4 py-3">Recent Time</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <tr
                                    key={item._id}
                                    className="border-b hover:bg-gray-100"
                                >
                                    <td className="px-4 py-3">{index + 1}</td>
                                    <td className="px-4 py-3">{item?.job?.title}</td>
                                    <td className="px-4 py-3">
                                        {item?.candidate?.name}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.candidate?.email}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.candidate?.number}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.statusType}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.submittedBy?.name}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.recentStatus?.status}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.recentStatus?.doj}
                                    </td>
                                    <td className="px-4 py-3">
                                        {item?.recentStatus?.scheduledDate}
                                    </td>
                                    <td className="px-4 py-3">
                                        {new Date(
                                            item?.recentStatus?.timestamp
                                        ).toLocaleString()}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center py-6">
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};